import React from "react";

import "./ComparisonFrame.css";

export const ComparisonFrame = ({ headline, children }) => {
  return (
    <div className="comparison-container">
      <div className="comparison-header">
        <h3 className="comparison-headline">{headline}</h3>
      </div>
      {children}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/ComparisonFrame.js